import { withRouter } from "react-router";
import { Warning } from "@material-ui/icons";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Typography,
} from "@material-ui/core";

import { RegistroReclamoProps } from "src/utils/interfaces";
import { getMainScroll, setQueryParam } from "src/utils/domAndURLs";
import { fechaEnFormatoHHMM, formatearIntervalo } from "src/utils/fechas";

const RegistroReclamo: React.FC<RegistroReclamoProps> = (
  props: RegistroReclamoProps
) => {
  const esFiscal = props.cargo?.toLowerCase().includes('fiscal');

  const esNoProcesada = props.motivo ? true : false;

  const reclamar = () => {
    const alturaActual = getMainScroll() ?? 0;
    const newURL = setQueryParam("previousHeight", alturaActual);
    const urlSinHost = `${newURL.pathname}${newURL.search}`;
    props.history.push(urlSinHost);

    const linkReclamo = `/reclamos/procesar/${props.id}?pageFrom=${props.location.pathname}`;
    props.history.push(linkReclamo);
  };

  const acciones = esNoProcesada ? (
    <CardActions>
      <Button size="small" color="primary" onClick={reclamar}>
        {esFiscal ? "gestionar" : "ver estado"}
      </Button>
    </CardActions>
  ) : null;

  return (
    <Card className="registro-historial mb-1">
      <CardContent>
        <div className="card-header">
          <Typography variant="subtitle1">
            {props.nombreOperario}
          </Typography>
        </div>
        
        <div className="card-header">
          <Typography variant="subtitle1">
            {props.nombrePuntoServicio}
          </Typography>
        </div>
        

        <div className="card-body">
          <div className="row">
            <div className="w-50">
              <Typography variant="body2" display="inline">
                Entrada:{" "}
              </Typography>

              <Typography variant="body2" display="inline">
                {fechaEnFormatoHHMM(props.cortes[0].horaEntrada)}
              </Typography>
            </div>

            <div className="w-50">
              <Typography variant="body2" display="inline">
                Salida:{" "}
              </Typography>

              <Typography variant="body2" display="inline">
                {fechaEnFormatoHHMM(props.cortes[0].horaSalida)}
              </Typography>
            </div>
          </div>

          <div className="row">
            <div>
              <Typography variant="body2" display="inline">
                Horas trabajadas:{" "}
              </Typography>

              <Typography variant="body2" display="inline">
                {formatearIntervalo(props.tiempoTrabajado)}
              </Typography>
            </div>
          </div>
          
        </div>

        <div className="card-header"></div>

        <div className="card-body">
          <Typography variant="subtitle1">
            Estado: {props.estadoReclamo}
          </Typography>
        </div>

        {esNoProcesada && (
          <Warning className="card-status-icon" color="secondary" />
        )}
      </CardContent>

      {acciones}
    </Card>
  );
};

export default withRouter(RegistroReclamo);
